import React, { PropsWithChildren, useCallback, useContext, useRef } from 'react';

import { CustomBottomSheetModalProvider } from '@/feature/alerts/components/CustomBottomSheetModalProvider';

import { SbkEntrySummaryModal, SbkEntrySummaryModalRef } from './SbkEntrySummaryModal';

type SbkEntrySummaryModalContextType = {
    showEntrySummaryModal: () => void;
    dismissEntrySummaryModal: () => void;
};

const SbkEntrySummaryModalContext = React.createContext<SbkEntrySummaryModalContextType | null>(null);

export const SbkEntrySummaryModalProvider: React.FC<PropsWithChildren> = ({ children }) => {
    const modalRef = useRef<SbkEntrySummaryModalRef>(null);

    const showEntrySummaryModal = useCallback(() => {
        modalRef.current?.show();
    }, []);

    const dismissEntrySummaryModal = useCallback(() => {
        modalRef.current?.dismiss();
    }, []);

    return (
        <CustomBottomSheetModalProvider>
            <SbkEntrySummaryModalContext.Provider value={{ showEntrySummaryModal, dismissEntrySummaryModal }}>
                {children}
                <SbkEntrySummaryModal ref={modalRef} />
            </SbkEntrySummaryModalContext.Provider>
        </CustomBottomSheetModalProvider>
    );
};

export const useSbkEntrySummaryModal = () => {
    const context = useContext(SbkEntrySummaryModalContext);
    if (!context) {
        throw new Error('useSbkEntrySummaryModal must be used within a SbkEntrySummaryModalProvider');
    }
    return context;
};
